module.exports = __webpack_public_path__ + "static/media/photo274.7ba36446.jpg";